import { render, staticRenderFns } from "./SnackBar.vue?vue&type=template&id=2b41bc6d&scoped=true"
import script from "./SnackBar.vue?vue&type=script&lang=js"
export * from "./SnackBar.vue?vue&type=script&lang=js"
import style0 from "./SnackBar.vue?vue&type=style&index=0&id=2b41bc6d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b41bc6d",
  null
  
)

export default component.exports